import { render } from "./NotFound.vue?vue&type=template&id=a02c5950"
const script = {}
script.render = render

export default script